import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M2.57039 13.3027C4.04777 12.3131 5.80985 12.021 7.45515 12.4268C7.84306 12.5224 8.03664 12.5707 8.05379 12.707C8.07071 12.8432 7.88136 12.9447 7.50301 13.1475C7.21625 13.3012 6.93523 13.4621 6.72859 13.5898C6.23399 13.879 5.30201 14.4243 4.62898 15.1084C4.19472 15.5498 3.62402 16.2836 3.51765 17.293C3.48484 17.6047 3.49911 17.904 3.55281 18.1875C3.60651 18.471 3.63337 18.6131 3.5616 18.6875C3.48976 18.7616 3.36987 18.7434 3.13093 18.707C2.10735 18.5512 1.41545 17.9932 0.847732 17.3848C0.423253 16.9298 0.203621 16.4063 0.257888 15.8467C0.308954 15.3211 0.590182 14.8973 0.871169 14.5879C1.31447 14.0998 1.96796 13.6863 2.35945 13.4385C2.44309 13.3855 2.5153 13.3396 2.57039 13.3027Z",
  "M6.00008 5.25C6.16569 5.25 6.32843 5.26223 6.48738 5.28613C6.67708 5.31466 6.77166 5.3294 6.82039 5.4082C6.86908 5.487 6.83557 5.5915 6.76765 5.80078C6.59399 6.33591 6.50008 6.90699 6.50008 7.5C6.50008 8.73987 6.91044 9.88384 7.60261 10.8037C7.73456 10.979 7.80052 11.067 7.78035 11.1572C7.76 11.2475 7.67475 11.292 7.50496 11.3809C7.05498 11.6164 6.54318 11.75 6.00008 11.75C4.20515 11.75 2.75008 10.2949 2.75008 8.5C2.75008 6.70507 4.20515 5.25 6.00008 5.25Z",
  "M16.546 12.4268C18.1913 12.0212 19.9535 12.3132 21.4308 13.3027C21.4859 13.3396 21.5572 13.3856 21.6408 13.4385C22.0321 13.6863 22.6856 14.0997 23.129 14.5879C23.41 14.8973 23.6913 15.3211 23.7423 15.8467C23.7966 16.4063 23.5779 16.9298 23.1535 17.3848C22.5857 17.9933 21.8931 18.5512 20.8693 18.707C20.6302 18.7434 20.5104 18.7618 20.4386 18.6875C20.3668 18.6131 20.3937 18.471 20.4474 18.1875C20.5011 17.904 20.5163 17.6047 20.4835 17.293C20.3772 16.2838 19.8064 15.5499 19.3722 15.1084C18.6992 14.4243 17.7672 13.879 17.2726 13.5898C17.0658 13.462 16.7842 13.3013 16.4972 13.1475C16.1189 12.9447 15.9296 12.8432 15.9464 12.707C15.9636 12.5707 16.1581 12.5224 16.546 12.4268Z",
  "M18.0001 5.25C19.7951 5.25 21.2501 6.70507 21.2501 8.5C21.2501 10.2949 19.7951 11.75 18.0001 11.75C17.4571 11.7499 16.9452 11.6164 16.4953 11.3809C16.3255 11.292 16.2402 11.2475 16.2199 11.1572C16.1997 11.0671 16.2657 10.979 16.3976 10.8037C17.0899 9.8838 17.5001 8.73995 17.5001 7.5C17.5001 6.90695 17.4062 6.33594 17.2326 5.80078C17.1647 5.59169 17.1313 5.48698 17.1798 5.4082C17.2285 5.32944 17.3233 5.31464 17.5128 5.28613C17.6717 5.26224 17.8346 5.25002 18.0001 5.25Z",
  "M7.69154 14.4733C10.3293 12.8422 13.675 12.8422 16.3128 14.4733C16.3906 14.5214 16.4891 14.579 16.6023 14.6452C17.1145 14.945 17.9277 15.4208 18.4826 15.9849C18.8312 16.3391 19.1787 16.8221 19.2421 17.4242C19.3099 18.0683 19.0365 18.6646 18.515 19.1806C17.6533 20.033 16.586 20.75 15.1865 20.75H8.8178C7.41834 20.75 6.35101 20.033 5.48939 19.1806C4.96783 18.6646 4.69442 18.0683 4.76223 17.4242C4.8256 16.8221 5.1732 16.3391 5.52173 15.9849C6.07663 15.4208 6.88982 14.945 7.40209 14.6452C7.51526 14.579 7.61377 14.5214 7.69154 14.4733Z",
  "M7.75187 7.5C7.75187 5.15279 9.65466 3.25 12.0019 3.25C14.3491 3.25 16.2519 5.15279 16.2519 7.5C16.2519 9.84721 14.3491 11.75 12.0019 11.75C9.65466 11.75 7.75187 9.84721 7.75187 7.5Z",
];

const MultipleUsersIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const clipId = `multiple-users-clip-${id}`;
  const gradientIds = paths.map(
    (_, index) => `multiple-users-gradient-${index}-${id}`,
  );

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <g opacity={isActive ? undefined : "0.5"}>
          {paths.map((path, index) => (
            <path key={path} d={path} fill={`url(#${gradientIds[index]})`} />
          ))}
        </g>
      </g>
      <defs>
        {gradientIds.map((gradientId) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            x1="22.1235"
            y1="6.84373"
            x2="9.33235"
            y2="24.5384"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

MultipleUsersIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

MultipleUsersIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default MultipleUsersIcon;
